const FIRST_BURST_MIN_CHARS = 1;
const BOUNDARY_SUFFIXES = ['。', '！', '？', '；', '.', '!', '?', ';', '\n'];

export function isFirstStreamingBurstReady(content = '') {
  const text = String(content ?? '');
  return text.length >= FIRST_BURST_MIN_CHARS || BOUNDARY_SUFFIXES.some((suffix) => text.endsWith(suffix));
}

export function resolveNextStreamingVisibleContent({
  targetContent = '',
} = {}) {
  const target = String(targetContent ?? '');
  return target;
}

export function useSmoothStreamingContent({
  content = '',
  streaming = false,
} = {}) {
  const target = String(content ?? '');

  return {
    pending: streaming && !target.trim(),
    visibleContent: target,
  };
}
